<template>
    <div class="greybox">
        <h1>Select the colour of your gadget...</h1>
        <div v-if="modelVersions.length > 0" class="mb-3">
            <div v-for="(versions, index) in modelVersionsGrouped" :key="index" class="row mt-3">
                <div v-for="(version, index) in versions" :key="index" class="col-md-4 align-self-center" align="center">
                    <div :class="getCardClass(selectedVersion, version)">

                        <img :src="version.image.path" :style="'width: 110px; height: 112px'" @click="setSelectedVersion(version)">

                        <h5 :class="'card-title'">{{version.colour.title}}</h5>
                    </div>
                </div>
            </div>
            <div
                v-if="!isSelectedVersionValid && nextAttempt"
                class="text-danger">
                <small>Please select the colour of your gadget</small>
            </div>
        </div>
        <div class="button-fluid-container">
            <button class="button" @click="handleBackClick()">Back</button>
            <button class="button" @click="addGadget()">Continue</button>
        </div>
        
        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>
<script>
import repairOptionsBase from '@/mixins/repairOptionsBase'
import loading from 'vue-loading-overlay'

import axios from 'axios'

let baseUrl = process.env.VUE_APP_API_BASE_URL

const chunk = (arr, chunkSize, cache = []) => {
  const tmp = [...arr]
  while (tmp.length) cache.push(tmp.splice(0, chunkSize))
  return cache
}

let required = (value) => {
  return !(value === undefined || value === null || value === '')
}

export default {
    name:'repairoptionsbookingmod',
    components: {
        loading
    },
    mixins: [
        repairOptionsBase
    ],
    data: () => {
        return {
            selectedVersion: null,
            nextAttempt: false,
            addDeviceMessage: null
        }
    },
    computed: {
        modelVersionsGrouped () {
            return chunk(this.modelVersions, 3)
        },
        isSelectedVersionValid () {
            return required(this.selectedVersion)
        }
    },
    //mounted () { this.isLoading=false /* HACK */ },
    methods: {
        getCardClass (selectedItem, item) {
            if (selectedItem) {
                return selectedItem == item ? 'my-card-selected my-card' : 'my-card'
            }

            return 'my-card'
        },
        setSelectedVersion (version) {
            this.selectedVersion = version
            //this.addGadget()
        },
        handleBackClick () {
            this.$router.push({path: '/myclaims/repairoptions/booking/'})
        },
        addGadget () {
            
            this.nextAttempt = true

            if (this.isSelectedVersionValid) {
                this.isLoading = true
                axios
                    .post(baseUrl + '/api/v1/booking/add/', {
                        gadgetWebReference: this.selectedGadgetId,
                        bookingReference: this.bookingReference,
                        modelVersionId: this.selectedVersion.id
                    })
                    .then(response => {
                        
                        let { bookingDates, deviceId, errorCode } = response.data.data
                        
                        this.bookingDates = bookingDates
                        this.deviceId = deviceId

                        this.handleErrorCode(errorCode)

                        if (this.bookingDates) {
                            this.$router.push({path: '/myclaims/repairoptions/bookingdte'})
                        }
                    })
                    .catch(error => {
                        this.isLoading = false
                    })
                    .finally(() => { this.isLoading = false})
            }
        },
        handleErrorCode (errorCode) {
            

            if (errorCode == 3) {
                this.addDeviceMessage = 'Sorry!  We have no technician available in that area.'
            }

            if (errorCode == 2) {
                this.addDeviceMessage = 'Please check the postcode that you have entered..'
            }

            // Booking alread exists in our DB for this gadget
            if (errorCode == 1000) {
                this.bookingExists = true
            }
        },
    }
}
</script>

